module.exports = __webpack_public_path__ + "img/goodsC1.985ac3c0.png";